import React from 'react';
import './FeaturedStall.scss';
import Card from '@material-ui/core/Card';

interface FeaturedLocalStoreItem {
  id: number;
  slotId: number;
  storeName: string;
  logoUrl: string | null;
  status?: 'ComingSoon' | 'Live' | 'ClosingSoon';
  slotStart: string;
  slotEnd: string;
}

const STATUS_LABEL: Record<string, string> = {
  Live: 'Open now',
  ClosingSoon: 'Closing soon',
  ComingSoon: 'Coming soon',
};

const STATUS_CLASS: Record<string, string> = {
  Live: 'text-success',
  ClosingSoon: 'text-danger',
  ComingSoon: '',
};

const formatTime = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

const formatDate = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });
};

// e.g. "Wed 18 Sep · 10:00 AM - 6:00 PM"; degrades gracefully if a piece is missing
// rather than showing nothing.
const formatTimingText = (item: FeaturedLocalStoreItem) => {
  const date = formatDate(item.slotStart);
  const start = formatTime(item.slotStart);
  const end = formatTime(item.slotEnd);
  const timeRange = start && end ? `${start} - ${end}` : (start || end || '');
  return [date, timeRange].filter(Boolean).join(' · ');
};

const Logo = ({ item, size }: { item: FeaturedLocalStoreItem; size: number }) => (
  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
    {item.logoUrl ? (
      <img
        src={item.logoUrl}
        alt={item.storeName}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', border: '1px solid #eee' }}
      />
    ) : (
      <div style={{ width: size, height: size, borderRadius: '50%', background: '#f0f0f0' }} />
    )}
  </div>
);

// Featured slide for a Local Store booking — same card shell/sizes as
// FeaturedStall (the merchant-stall slide), so it drops into the same
// orange "Featured" Slider without disturbing that component or its data.
const FeaturedLocalStore = (props: { item: FeaturedLocalStoreItem; navToLocalStore: (item: FeaturedLocalStoreItem) => void }) => {
  const { item } = props;
  const statusLabel = STATUS_LABEL[item.status || 'ComingSoon'];
  const statusClass = STATUS_CLASS[item.status || 'ComingSoon'];
  const timingText = formatTimingText(item);

  return (
    <div className="featuredStall-ui pt-5" onClick={() => props.navToLocalStore(item)}>

      {/* Desktop View */}
      <div className="deskview">
        <Card className="pointer" style={{ width: "250px", height: "250px" }}>
          <div className="p-5">
            <div className="text-center">
              <Logo item={item} size={48} />
              <div className="font-20">{item.storeName}</div>
              <div className="font-14 py-1"><b><span className={statusClass}>{statusLabel}</span></b></div>
              {timingText && <div className="font-14 pb-3">{timingText}</div>}
            </div>
          </div>
        </Card>
      </div>

      {/* Tablet View */}
      <div className="tabview">
        <Card className="pointer" style={{ backgroundColor: "#F8F5EF", width: "600px", height: "250px", color: "#6D4B40" }}>
          <div className="p-2 pt-4">
            <div className="text-center">
              <Logo item={item} size={56} />
              <div className="font-22"><b>{item.storeName}</b></div>
              <div className="font-16 py-3"><b><span className={statusClass}>{statusLabel}</span></b></div>
              {timingText && <div className="font-16 pb-5">{timingText}</div>}
            </div>
          </div>
        </Card>
      </div>

      {/* Mobile View */}
      <div className="mobileview">
        <Card className="pointer" style={{ backgroundColor: "#F8F5EF", width: "300px", height: "150px", color: "#6D4B40" }}>
          <div className="p-2">
            <div className="text-center">
              <Logo item={item} size={32} />
              <div className="font-16"><b>{item.storeName}</b></div>
              <div className="font-12 py-1"><b><span className={statusClass}>{statusLabel}</span></b></div>
              {timingText && <div className="font-12 pb-3">{timingText}</div>}
            </div>
          </div>
        </Card>
      </div>

    </div>
  );
}
export default FeaturedLocalStore;
